import clsx from "clsx";

import { useTheme } from "@/lib/theme";
import cloveBlack from "@/assets/brand/clove-black.png";
import cloveWhite from "@/assets/brand/clove-white.png";

/*
 * The client's logo, in the colour that reads on the current theme: the white
 * mark on the dark theme, the black one on the light. The orange "V" is the
 * same in both, so the swap is only ever the lettering.
 *
 * Sized by height, because the logo is a wide wordmark (about 2.8 : 1) and the
 * places it goes - a sidebar header, a sign-in card - are constrained
 * vertically, not horizontally.
 */
export function ClientLogo({ height = 32, className }: { height?: number; className?: string }) {
  const { theme } = useTheme();
  return (
    <img
      src={theme === "light" ? cloveBlack : cloveWhite}
      alt="Clove Technologies"
      draggable={false}
      className={clsx("block w-auto select-none", className)}
      style={{ height }}
    />
  );
}
